import { Icon } from '@tallink/components-lib'
import { useQuery } from '@tallink/more-react-hooks'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import SerialTicketsClient from '../../../clients/SerialTicketsClient'
import { getReservation } from '../../../selectors/selectors'
import s from './OrderDetails.module.scss'

export default function OrderDetails() {
  const { t } = useTranslation()
  const {
    pin,
    resId,
    contactPerson: { firstName, lastName, email }
  } = useSelector(getReservation)

  return (
    <div className={s['order-details']}>
      <DescriptionAndValue description={t('confirmation.summary.orderNumber')} value={`${resId}`} />
      <DescriptionAndValue description={t('confirmation.summary.securityCode')} value={pin} />
      <DownloadPdf />
      <DescriptionAndValue description={t('confirmation.summary.contactPerson')} value={`${firstName} ${lastName}`} />
      <DescriptionAndValue description={t('confirmation.summary.email')} value={email} />
    </div>
  )
}

function DescriptionAndValue({ description, value }) {
  return (
    <div className={s['description-value']}>
      <div className={s.description}>{description}</div>
      <div className={s.value}>{value}</div>
    </div>
  )
}

DescriptionAndValue.propTypes = {
  description: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
}

function DownloadPdf() {
  const { t } = useTranslation()
  const resToken = useQuery('resToken')

  return (
    <a className={s['download-pdf']} href={SerialTicketsClient.createPdfLink(resToken)}>
      <Icon type="download" />
      {t('confirmation.summary.downloadPdf')}
    </a>
  )
}
